import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import VuexPersistence from 'vuex-persist';
import { actions } from '@/store/actions';
import { RootState } from '@/store/types';
import { mutations } from '@/store/mutations';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence<RootState>({
  storage: window.localStorage,
  key: 'l&c',
});

const state = {
  version: '1.0.0',
  user: null,
  exerciseTypes: [
    {
      name: 'Warm Up',
      value: 0,
    },
    {
      name: 'Exercise',
      value: 1,
    },
    {
      name: 'Homework',
      value: 2,
    },
    {
      name: 'Feedback Question',
      value: 3,
    },
    {
      name: 'Intro Question',
      value: 4,
    },
  ],
  sessionTypes: [
    {
      name: 'Work of the day',
      value: 0,
    },
    {
      name: 'First 7',
      value: 1,
    },
    {
      name: 'Schedule',
      value: 2,
    },
  ]
};

const store: StoreOptions<RootState> = {
  state,
  actions,
  mutations,
  plugins: [
    vuexLocal.plugin
  ]
};

export default new Vuex.Store<RootState>(store);
